/**
 * tabs
 */

class Tabs {
  constructor() {
    this.$ = {
      tabs: $('.js-tabs')
    };

    if (this.$.tabs.length) {
      $.extend(this.$, {
        tab: this.$.tabs.find('.js-tabs-item'),
        label: this.$.tabs.find('.js-tabs-label'),
        line: this.$.tabs.find('.js-tabs-line')
      });

      const index = this.getIndexFromHash();

      this.state = {
        index
      };

      this.init();
    }
  }
  init() {
    this.$.line.show();
    this.$.tab.hide();
    this.setLinePosition(this.state.index);
    this.setActiveLabel(this.state.index);
    this.setActiveTab(this.state.index);
    this.initEvents();
  }
  initEvents() {
    this.$.label.on('click', e => this.clickHandler(e));
  }
  clickHandler(e) {
    e.preventDefault();
    e.stopPropagation();

    const $target = $(e.currentTarget);
    const href = $target.attr('href');
    const index = $target.index();

    this.setHash(href);
    this.setActiveLabel(index);
    this.setActiveTab(index);
  }
  setActiveLabel(index) {
    this.$.label.removeClass('is-active');
    this.$.label.eq(index).addClass('is-active');
    this.setLinePosition(index);
  }
  setActiveTab(index) {
    const $prev = this.$.tab.eq(this.state.index);
    const $next = this.$.tab.eq(index);

    $prev.removeClass('is-active');
    $next.addClass('is-active');

    $prev.fadeOut(300, () => {
      $next.fadeIn(300);
      this.state.index = index;
    });
  }
  setLinePosition(index) {
    const label = this.$.label.eq(index);
    const labelWidth = label.outerWidth();
    const labelOffset = label.offset().left;

    this.$.line.width(labelWidth).offset({ left: labelOffset });
  }
  getIndexFromHash() {
    const index = parseInt(window.location.hash.substr(5) - 1);
    return isNaN(index) || index === -1 ? 0 : index;
  }
  setHash(value) {
    window.location.hash = value;
  }
}

export default new Tabs();
